module.exports = __webpack_public_path__ + "img/grade12.392a47c8.png";